

import { IDataAccessor, AbstractAccessorService } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import { IProductCategories } from "../model/product-categories";
import { IProductCategoriesRestService } from "./product-categories-rest";


export class ProductCategoriesRestService extends AbstractAccessorService<Array<IProductCategories>> implements IProductCategoriesRestService {
    public readonly $name: string = "ProductCategoriesRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<Array<IProductCategories>>) {
        super();
    }

    
    /**
     * @description 简易价格计算
     * @param configurableProductId 可配置产品ID
     * @returns 
     */
    public getCategories(productId: number): angular.IPromise<IResponse<Array<IProductCategories>>> {
        return this.$accessor<Array<IProductCategories>, { productId: number }, string>(this.$name, "getCategories", {
            parameter: {
                productId: productId
            }
        });
    }
}